import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { StickyCTA } from "./components/StickyCTA";
import Home from "./pages/Home";
import Servizi from "./pages/Servizi";
import ComeFunziona from "./pages/ComeFunziona";
import Zone from "./pages/Zone";
import ZonaLanding from "./pages/ZonaLanding";
import Contatti from "./pages/Contatti";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = () => (
  <>
    <ScrollTop />
    <div className="grain" aria-hidden="true" />
    <Header />
    <main className="min-h-screen bg-[#050505]">
      <Outlet />
    </main>
    <Footer />
    <StickyCTA />
  </>
);

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#050505]">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/come-funziona" element={<ComeFunziona />} />
            <Route path="/zone" element={<Zone />} />
            <Route path="/zone/:slug" element={<ZonaLanding />} />
            <Route path="/contatti" element={<Contatti />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
